/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 查询
export const getVehicles = (data) => {
    return request({
        url: `/api-tms/dispatch/carmanagesearch`,
        method: 'post',
        data
    });
};

// 头部数据统计
export const getVehicleLists = (params) => {
    return request({
        url: `/api-tms/dispatch/dispatchstatusort`,
        method: 'post',
        data: params
    });
};
